import { fromJS, OrderedMap } from 'immutable'
import { LOGOUT } from '../authentication/constants'
import * as actionTypes from './constants'
import { CLEAR_PROJECT } from '../PlanSelection/constants'

const initialState = fromJS({
  planFolders: {},
  planFolderTimestamps: {},
  planSearch: ''
})

function quickSelectProjectReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.OPEN_PROJECTS:
      return state.set('projectsOpen', true).set('plansOpen', false)
    case actionTypes.CLOSE_PROJECTS:
      return state.set('projectsOpen', false).set('projectFilter', '')
    case actionTypes.OPEN_PROJECT_FOLDER:
      return state.set('projectFolders', action.folders)
    case actionTypes.OPEN_PLANS:
      return state.set('plansOpen', true).set('projectsOpen', false)
    case actionTypes.CLOSE_PLANS:
      return state.set('plansOpen', false).set('planFilter', '')
    case actionTypes.OPEN_PLAN_FOLDER:
      return state.set('planFolders', action.folders)
    case actionTypes.SET_PROJECT_FILTER:
      return state.set('projectFilter', action.filter)
    case actionTypes.SET_PLAN_FILTER:
      return state.set('planFilter', action.filter)
    case CLEAR_PROJECT:
      return state.set('projectFolders', '').set('projectFilter', '')

    case actionTypes.CLEAR_PLAN_FOLDER_SELECT_BOX: {
      let newState = state
      if (newState.get('planSearch')) {
        newState = newState
          .set('planSearch', '')
          .set('planFolders', fromJS({}))
          .delete('rootPlansObject')
      }
      return newState.delete('currentPlanFolderId')
    }
    case actionTypes.SET_CURRENT_PLAN_FOLDER_ID:
      return state.set('currentPlanFolderId', action.currentFolderId)
    case actionTypes.CLEAR_PLANS:
      return state
        .delete('rootPlansObject')
        .set('planFolders', fromJS({}))
        .set('planFolderTimestamps', fromJS({}))
    case actionTypes.CLEAR_FOLDER_PLANS:
      return state.setIn(
        ['planFolders', action.folderId],
        fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        }).set('content', new OrderedMap())
      )
    case actionTypes.GET_ROOT_PLANS:
      return state
        .set('gettingRootPlans', true)
        .set(
          'planSearch',
          typeof action.search === 'string'
            ? action.search
            : state.get('planSearch')
        )
        .delete('getRootPlansError')
        .set('savedProjectId', action.projectId)
    case actionTypes.GET_ROOT_PLANS_DONE: {
      let rootPlansObject = state.has('rootPlansObject')
        ? state.get('rootPlansObject')
        : fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0,
          rootId: null
        })

      // set page options
      rootPlansObject = rootPlansObject.merge(fromJS(action.plans))

      const pageNumber = action.plans.number

      // add content to content, id is already there -> merge it
      let content = state.has('rootPlansObject')
        ? state.getIn(['rootPlansObject', 'content'])
        : new OrderedMap()

      // delete all entries of current page
      content = content.filterNot(
        (element) => element.get('pageNumber') === pageNumber
      )

      action.plans.content.forEach((element) => {
        content = content.set(element.id, fromJS({ ...element, pageNumber }))
      })

      return state
        .set('gettingRootPlans', action.cached)
        .set('rootPlansObject', rootPlansObject.set('content', content))
        .delete('getPlanTreeCancelToken')
        .set('rootPlansTimestamp', action.timestamp)
    }
    case actionTypes.GET_ROOT_PLANS_ERROR:
      return state
        .set('gettingRootPlans', false)
        .set('getRootPlansError', action.error)

    // is called when there is still content to load
    case actionTypes.GET_FOLDER_PLANS: {
      let newState = state

      if (!newState.hasIn(['planFolders', action.folderId])) {
        const folder = fromJS({
          totalPages: 0,
          totalElements: 0,
          number: 0
        })

        newState = newState.setIn(
          ['planFolders', action.folderId],
          folder.set('content', new OrderedMap())
        )
      }

      return newState
        .set('gettingFolderPlans', action.folderId)
        .delete(`getFolderPlansError${action.folderId}`)
    }
    case actionTypes.GET_FOLDER_PLANS_DONE: {
      // object is already there because it's created on GET_FOLDER_PLANS
      let folderPlansObject = state.getIn(['planFolders', action.folderId])

      if (folderPlansObject) {
        // set page options
        folderPlansObject = folderPlansObject.merge({
          ...action.plans,
          parentId:
            typeof action.parentId === 'undefined'
              ? action.plans.parentId
              : action.parentId
        })

        // add content to content, id is already there -> merge it
        let content = state.hasIn(['planFolders', action.folderId])
          ? state.getIn(['planFolders', action.folderId, 'content'])
          : new OrderedMap()

        const pageNumber = action.plans.number

        // delete old items of current page
        content = content.filterNot(
          (element) => element.get('pageNumber') === pageNumber
        )

        action.plans.content.forEach((element) => {
          content = content.set(element.id, fromJS({ ...element, pageNumber }))
        })

        return state
          .set('gettingFolderPlans', action.cached)
          .setIn(
            ['planFolders', action.folderId],
            folderPlansObject.set('content', content)
          )
          .delete('getPlanTreeCancelToken')
          .setIn(['planFolderTimestamps', action.folderId], action.timestamp)
      }
      return state
    }
    case actionTypes.GET_FOLDER_PLANS_ERROR:
      return state
        .set('gettingFolderPlans', false)
        .set(`getFolderPlansError${action.folderId}`, action.error)
    case actionTypes.SET_GET_PLAN_TREE_CANCEL_TOKEN:
      return state.set('getPlanTreeCancelToken', action.cancelToken)

    case LOGOUT:
      return initialState
    default:
      return state
  }
}

export default quickSelectProjectReducer
